<template>
  <div class="modifytextarea-box">
    <!-- TextArea -->
    <textarea
      rows="1"
      class="modiftyArea"
      name="modiftyArea"
      id="modiftyArea"
      ref="textArea"
      :placeholder="placeholder"
      @input="inputEvent"
      @compositionstart="isComposing = true"
      @compositionend="handleCompositionEnd"
    ></textarea>
    <!-- Cancel/Save Btn-->
    <div class="modifytextArea-btngroup">
      <button class="modifytextArea-btn cursor" tabindex="0" @click="$emit('cancelbtn-event')">취소</button>
      <button class="modifytextArea-btn red cursor" :disabled="isDisabled" tabindex="0" @click="onSaveBtnClick">
        수정
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    contents: {
      type: String,
      default: '',
      required: false
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    }
  },
  emits: ['change-textarea', 'cancelbtn-event', 'savebtn-event'],
  data() {
    return {
      textareaContents: '',
      isComposing: false
    };
  },
  created() {
    this.textareaContents = this.contents;
  },
  async mounted() {
    this.$refs.textArea.value = this.textareaContents;
    await this.$nextTick();
    this.setAutoHeight();
  },
  methods: {
    setAutoHeight() {
      const el = this.$refs.textArea;
      el.style.height = 'auto';
      const max = 180;
      const height = el.scrollHeight;
      el.style.height = Math.min(height, max) + 'px';
    },
    inputEvent(e) {
      if (e.target) {
        // 최대높이 180px
        this.setAutoHeight();
        this.textareaContents = e.target.value;
        this.$emit('change-textarea', e.target.value, this);
      }
    },
    handleCompositionEnd() {
      this.isComposing = false;
    },
    onSaveBtnClick() {
      this.$emit('savebtn-event', this.textareaContents);
    },
    sliceTextArea(max) {
      if (this.$refs.textArea.value.length > max) {
        this.$refs.textArea.value = this.$refs.textArea.value.slice(0, max);
        this.textareaContents = this.$refs.textArea.value;
      }
      this.setAutoHeight();
    }
  },
  computed: {
    isDisabled() {
      if (this.textareaContents) {
        return false;
      }
      return true;
    }
  }
};
</script>
<style scoped src="@/assets/css/modifytextarea/modifytextarea.css"></style>
